import React, { useEffect, useState } from "react";
// import FacetMultiSelectComponent from './facetComponent/FacetMultiSelectComponent/FacetMultiSelectComponent';
// import FacetSingleSelectComponent from './facetComponent/FacetSingleSelectComponent/FacetSingleSelectComponent';
import { useTranslation } from "react-i18next";
import { FiPlus, FiMinus } from "react-icons/fi";
import { FiX } from "react-icons/fi";

export const ResourceLibraryFilter = ({
  searchResults,
  onFilterChange,
  facetName,
  isAll,
  selectFirst = true,
  ...props
}) => {
  const { t } = useTranslation();
  const [facetOptionResults, setFacetOptionResults] = useState([]);
  let loading = false;
  const [openIndexes, setOpenIndexes] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [searchText, setSearchText] = useState('')
  const [filterText, setFilterText] = useState('')
  const [selectedFilters, setSelectedFilters] = useState({})

  useEffect(() => {
    if (selectedDocs) {
      props?.getFilteredData(selectedDocs, filterText)
    }
  }, [selectedDocs])

  const handleNav = (event) => {
    event.stopPropagation();
    event.preventDefault();

    let targetElmClass =
      event.target.getAttribute("data-for") ||
      event.currentTarget.getAttribute("data-for");
    let navElm = document.querySelector(`.sd-tableContent.${targetElmClass}`);
    let dropdownMenu = navElm?.querySelector(".sd-dropdown-inner-menu");
    let closeBtn = navElm?.querySelector("button.sd-closeBtn");
    if (navElm) {
      if (navElm.classList.contains("sd-expanded")) {
        navElm.classList.remove("sd-expanded");
        if (navElm.classList.contains("sd-trapFocus")) {
          navElm.classList.remove("sd-trapFocus");
        }
        if (event.target.getAttribute("data-target")) {
          document
            .querySelector(`.${event.target.getAttribute("data-target")}`)
            ?.focus();
        }
        if (!dropdownMenu?.classList.contains("lg:sd-hidden")) {
          dropdownMenu?.classList.add("lg:sd-hidden");
        }
      } else {
        if (!navElm.classList.contains("sd-expanded")) {
          navElm.classList.add("sd-expanded");
          closeBtn.focus();
          if (!navElm.classList.contains("sd-trapFocus")) {
            navElm.classList.add("sd-trapFocus");
          }
        }
      }
      // toggleOverlay();
    }
    const targetId = event.currentTarget.getAttribute("id");
    if (targetId) {
      closeBtn.setAttribute("data-targetId", targetId);
    }
  };


  const toggleAccordion = (index) => {
    if (openIndexes.includes(index)) {
      // If already open, remove it from the openIndexes array
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      // Otherwise, add it to the openIndexes array
      setOpenIndexes([...openIndexes, index]);
    }
  };

  const handleInputChage = (e) => {
    setSearchText(e.target.value)

  }

  const toTitleCase = (str) => {
    return str
      .replace(/([A-Z])/g, ' $1') // Insert a space before each uppercase letter
      .replace(/^./, (char) => char.toUpperCase()) // Capitalize the first letter
      .trim(); // Remove any extra spaces
  }

  const filterSelectedOption = (option, mainKeyName = '') => {

    setSelectedDocs((prev) => {
      const exists = prev.some(
        (item) => item.docCount === option.docCount && item.docType === option.docType && item.mainKey === mainKeyName
      );

      if (exists) {
        // If it exists, remove it
        return prev.filter(
          (item) =>
            !(item.docCount === option.docCount && item.docType === option.docType && item.mainKey === mainKeyName)
        );
      } else {
        // If it doesn't exist, add it
        return [...prev, { ...option, mainKey: mainKeyName }];
      }
    });

  };

  const removeTag = (tagToRemove) => {
    setSelectedDocs((prevTags) =>
      prevTags.filter(
        (tag) =>
          !(tag.docCount === tagToRemove.docCount && tag.docType === tagToRemove.docType && tag.mainKey === tagToRemove.mainKey)
      )
    );
  };

  const handleKeyDown = (event) => {
    const searchQuery = event.target.value;

    if (event.key === "Enter" && searchQuery?.trim()?.length > 2) {
      setFilterText(searchQuery)
      props?.getFilteredData(selectedDocs, searchQuery)
      //   handleSearchQueryChange(searchQuery);
    }
    else if (event.key === "Enter" && searchQuery?.trim()?.length === 0) {
      cancelSearchText()
    }


  };

  const cancelSearchText = () => {
    setSearchText('')
    setFilterText('')
    props?.getFilteredData(selectedDocs, '*')
  }




  return (
    <React.Fragment>


      <div className="sd-pt-6 sd-pb-[34px] lg:sd-pl-4">
        <h3 className="sd-mb-[10px]">SEARCH</h3>
        <div className="sd-bg-[#E9E9E9] sd-rounded-full sd-px-4 sd-mr-4 sd-py-3 sd-flex sd-items-center">
          <input
            onKeyDown={handleKeyDown}
            type="text"
            placeholder="SEARCH ANY TOPIC"
            className="sd-bg-transparent sd-border-none sd-outline-none sd-w-full"
            onChange={e => { handleInputChage(e) }}
            value={searchText}
          />
        </div>
      </div>

      <div className="sd-h-full">
        <div className="sd-navigation sd-w-full">

          <div className="sd-mt-4 lg:sd-mt-0 sd-hidden lg:sd-block">

            <div className="sd-grid sd-grid-cols-12 sd-gap-4 lg:sd-border-none sd-border-b">
              <div className="sd-pl-4 sd-sdList lg:sd-col-span-12 sd-col-span-4">



                {(selectedDocs?.length > 0 || filterText.length > 0) &&
                  <div className="sd-py-4 sd-pb-6">
                    <h3 className="sd-uppercase sd-mb-2">
                      {facetName ? facetName : t("filterBy")}
                    </h3>
                    <div className="sd-flex sd-flex-wrap sd-gap-2">
                      {filterText.length > 0 &&
                        <div
                          className="sd-flex sd-items-center sd-bg-gray-200 sd-rounded-full sd-px-4 sd-py-2 sd-text-sm sd-font-medium sd-text-gray-700 sd-cursor-pointer hover:sd-bg-gray-300"
                        >
                          <span>{filterText}</span>
                          <FiX
                            className="sd-ml-2 sd-text-gray-500 hover:sd-text-gray-700"
                            onClick={() => { cancelSearchText() }}
                          />
                        </div>
                      }
                      {selectedDocs?.map((tag, index) => (
                        <div
                          key={index}
                          className="sd-flex sd-items-center sd-bg-gray-200 sd-rounded-full sd-px-4 sd-py-2 sd-text-sm sd-font-medium sd-text-gray-700 sd-cursor-pointer hover:sd-bg-gray-300"
                        >
                          <span>{tag.docType}</span>
                          <FiX
                            className="sd-ml-2 sd-text-gray-500 hover:sd-text-gray-700"
                            onClick={() => removeTag(tag)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                }
                <h1 className="sd-uppercase ">
                  {facetName ? facetName : t("filtercat")}
                </h1>
              </div>
            </div>
          </div>

          {searchResults && (
            <div className="lg:sd-hidden sd-fixed sd-w-full sd-bottom-0 sd-h-[52px] sd-bg-gray-103 sd--mx-4 sd-z-30 sd-py-2">
              <div className="sd-relative sd-grid sd-grid-cols-8 sd-w-full">
                <div className="sd-absolute sd-w-max sd--top-16 sd-left-0 sd-right-0 sd-mx-auto sd-flex">
                  <button
                    onClick={(event) => handleNav(event)}
                    data-for="sd-filterBlock"
                    className="navBtn  sd-uppercase sd-text-xs sd-text-white  sd-bg-gray-103 sd-rounded-full  sd-py-4 sd-px-6 sd-z-50"
                  >
                    {t("filtercat")}
                  </button>
                </div>
              </div>
              <div className="sd-grid sd-grid-cols-8">
                <span className="sd-font-sf sd-mb-[9px] sd-text-white sd-text-center sd-block sd-col-span-8 sd-flex sd-justify-center sd-items-center sd-text-xs">
                  <svg
                    className="sd-mr-2"
                    width="6"
                    height="9"
                    viewBox="0 0 6 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.908203 8.78687H5.0918C5.65869 8.78687 5.93555 8.50562 5.93555 7.89038V4.66479C5.93555 4.11108 5.70703 3.82544 5.23682 3.7771V2.66968C5.23682 1.01294 4.15137 0.213135 3 0.213135C1.84863 0.213135 0.763184 1.01294 0.763184 2.66968V3.79907C0.763184 3.86499 0.33252 4.14624 0.0644531 4.66479V7.89038C0.0644531 8.50562 0.341309 8.78687 0.908203 8.78687ZM1.4707 2.57739C1.4707 1.47437 2.17822 0.889893 3 0.889893C3.82178 0.889893 4.5293 1.47437 4.5293 2.57739V3.77271L1.4707 3.7771V2.57739Z"
                      fill="white"
                      fillOpacity="0.5"
                    ></path>
                  </svg>
                  <a
                    href="http://www.sandisk.com"
                    className="sd-text-decoration-none"
                  >
                    sandisk.com
                  </a>
                </span>
                <span className="sd-h-[5px] sd-bg-white sd-text-center sd-block sd-w-full sd-col-span-4 sd-col-start-3 sd-mx-auto sd-rounded-full"></span>
              </div>
            </div>
          )}
          <div className="sd-tableContent sd-filterBlock  sd-pt-0 sd-pb-11 sd-fixed  lg:sd-relative sd-w-full sd-text-white lg:sd-text-black sd-z-30 lg:sd-relative sd-tableContent sd-grey-bg sd-backdrop-blur-tf lg:sd-bg-transparent sd-rounded-t-lg lg:rounded-none sd--mx-4 lg:sd-mx-0">
            <div className=" sd-max-content-width sd-mx-auto">
              <div className="sd-px-4 sd-pt-[14px] lg:sd-pt-0">
                <div className="sd-grid sd-grid-cols-8 sd-gap-4 lg:sd-gap-0 sd-sticky lg:sd-relative sd-top-0 sd-border-b lg:sd-border-none sd-pb-[14px] lg:sd-pb-0 sd-block lg:sd-hidden sd-mb-6">
                  <div className="lg:sd-py-4 lg:sd-border-b lg:sd-col-span-8 sd-col-span-8 sd--mx-4 sd-px-4">
                    <div className="sd-flex lg:sd-flex-row sd-flex-col lg:sd-justify-between lg:sd-items-center">
                      <button data-for="sd-filterBlock" onClick={(event) => handleNav(event)} class="sd-bg-white sd-rounded-full sd-min-w-6 sd-min-h-6 sd-flex sd-items-center sd-justify-center sd-fill-black sd-closeBtn sd-absolute sd-top-[-15px] sd-right-[-16px] sd-m-4">
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.41808 3.06255L4.63617 4.84446L6.41808 6.62637L5.90896 7.13548L4.12706 5.35357L2.34515 7.13548L1.83603 6.62637L3.61794 4.84446L1.83603 3.06255L2.34515 2.55343L4.12706 4.33534L5.90896 2.55343L6.41808 3.06255Z" fill="black"></path>
                        </svg>
                      </button>
                      <div className="sd-py-4">
                        <h1 className="sd-text-sm  sd-mb-2">SEARCH</h1>
                        <div className="sd-bg-[#E9E9E9] sd-rounded-full sd-px-4 sd-py-2 sd-flex sd-items-center">
                          <input
                            type="text"
                            placeholder="TYPE ANYTHING"
                            className="sd-bg-transparent sd-border-none sd-outline-none sd-text-sm sd-text-gray-500 sd-w-full"
                          />
                        </div>
                      </div>
                      <div className="sd-py-4 sd-pb-6">
                        <h1 className="sd-uppercase sd-mb-2">
                          {facetName ? facetName : t("filterBy")}
                        </h1>
                        <div className="sd-flex sd-flex-wrap sd-gap-2">

                          {filterText.length > 0 &&
                            <div
                              className="sd-flex sd-items-center sd-bg-gray-200 sd-rounded-full sd-px-4 sd-py-2 sd-text-sm sd-font-medium sd-text-gray-700 sd-cursor-pointer hover:sd-bg-gray-300"
                            >
                              <span>{filterText}</span>
                              <FiX
                                className="sd-ml-2 sd-text-gray-500 hover:sd-text-gray-700"
                                onClick={() => setSearchText('')}
                              />
                            </div>
                          }
                          {selectedDocs?.map((tag, index) => (
                            <div
                              key={index}
                              className="sd-flex sd-items-center sd-bg-gray-200 sd-rounded-full sd-px-4 sd-py-2 sd-text-sm sd-font-medium sd-text-gray-700 sd-cursor-pointer hover:sd-bg-gray-300"
                            >
                              <span>{tag.docType}</span>
                              <FiX
                                className="sd-ml-2 sd-text-gray-500 hover:sd-text-gray-700"
                                onClick={() => removeTag(tag)}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                      <h3 className="sd-mb-0 lg:sd-mb-[7px] sd-block sd-leading-lineHeight120 sd-text-n-offwhite lg:sd-text-black">
                        {t("filtercat")}
                      </h3>

                    </div>
                  </div>
                </div>
                <div className="sd-custom-radio-btn sd-mt-2">

                  <div className="sd-w-full sd-max-w-md sd-mx-auto sd-bg-[#FFFCF9] ">
                    {
                      searchResults?.map((item, index) => {
                        const categoryName = Object.keys(item)[0];
                        const categoryData = item[categoryName];
                        console.log(JSON.stringify(categoryData));
                        if (categoryData.length > 0) {
                          return (
                            <div key={index} className="sd-border-b last:sd-border-b-0">
                              <button className="sd-flex sd-justify-between sd-items-center sd-w-full sd-px-4 sd-pt-4 sd-text-left sd-text-black" onClick={() => toggleAccordion(index)}>
                                <p className="sd-mb-0">{toTitleCase(categoryName)}</p>
                                {openIndexes.includes(index) ? (
                                  <FiMinus className="sd-text-lg sd-text-gray-500" />
                                ) : (
                                  <FiPlus className="sd-text-lg sd-text-gray-500" />
                                )}
                              </button>
                              {openIndexes.includes(index) && (
                                <div className="sd-px-4 sd-pt-2 sd-text-gray-600">
                                  {categoryData.map((option, optionIndex) => (
                                    <div className="sd-py-2 sd-pr-2" key={optionIndex}>
                                      <label aria-labelledby={`capacity-heading capacity_val${optionIndex + 1}`}>
                                        <input type="checkbox" name={`option.docType_${optionIndex + 1}`} id={`capacity_val${optionIndex + 1}`} checked={selectedDocs.some((selected) => selected.docCount === option.docCount && selected.docType === option.docType)} onChange={() => filterSelectedOption(option, categoryName)} />
                                        <p className="sd-flex sd-justify-between sd-pl-2 sd-w-full sd-mb-0 sd-capitalize">
                                          {option.docType}{" "}
                                          {option.docCount ? `(${option.docCount})` : ""}
                                        </p>
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        } else {
                          // If the category has no data, do not render  it
                          return <div>test</div>;
                        }
                      })}
                  </div>

                  {/* {!isSingleSelection && <FacetSingleSelectComponent
                                        facetOptionResults={facetOptionResults}
                                        filterSelectedOption={filterSelectedOption}
                                        loading={loading}
                                    />}
                                    {isSingleSelection && <FacetMultiSelectComponent
                                        facetOptionResults={facetOptionResults}
                                        filterSelectedOption={filterSelectedOption}
                                        loading={loading}
                                    />} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResourceLibraryFilter;
